import React from "react";
import { RadioGroup } from "react-materialize";

const SelectType = ({ type, handleEvents }) =>
  React.createElement(
    "div",
    { id: "select-type-chart" },
    React.createElement("span", { id: "title" }, "Organization Chart"),
    React.createElement(
      "div",
      { id: "radiogroup" },
      React.createElement(RadioGroup, {
        label: "",
        name: "type-chart",
        onChange: handleEvents.SelectType.OnChange,
        options: [
          { label: "Hybrid", value: "hybrid" },
          { label: "Functional", value: "functional" },
          { label: "Role", value: "role" },
        ],
        value: type,
        withGap: true })
    )
  );

export default SelectType;

